import React from "react";

const ACTS = [
  {
    numeral: "I",
    title: "Act One – rehearsed reading",
    copy: [
      "We interview you in depth, discover the heart of your story or mission and create an original stage play. We cast professional actors (or one actor in the case of a one person play), secure an experienced director, and put on a rehearsed reading in front of a select audience followed by an optional Q&A with you or someone from your business. This will be recorded, with the final script published.",
    ],
  },
  {
    numeral: "II",
    title: "Act Two – full performance",
    copy: [
      "The play will be rehearsed for 2-3 weeks and brought to life under the lights. It will be marketed, professionally recorded, and followed by post-show networking. This can be one night only or a full run with the option to tour the piece and bring it into schools and other businesses.",
    ],
  },
  {
    numeral: "III",
    title: "Act Three – afterlife and return on investment",
    copy: [
      <>This production won’t simply offer a powerful experience for those who come to see it, it will also boost your personal profile and help you gain new clients. Inviting CEOs to my last play had a <strong className="st-stat-inline">40% higher acceptance rate</strong> than for a coffee morning with a founder of a billion-pound business.</>,
      "The recording, script and audience reaction videos, plus the fact your story is the subject of a play, will provide valuable marketing opportunities for years. It will also save time and deepen trust with colleagues and clients because, by watching or reading your story, they will learn things about you they might otherwise never uncover. And you will learn new things about yourself and gain clarity on the story that will take you and your business forwards.",
    ],
    aside: (
      <p className="st-stat" aria-hidden="true" data-testid="st-stat">
        <span className="st-stat-number">40%</span>
        <span className="st-stat-label">higher acceptance rate</span>
      </p>
    ),
  },
];

export const StoryActs = () => (
  <ol className="st-acts" data-testid="st-acts">
    {ACTS.map((act, i) => (
      <li key={act.numeral} className={`st-act st-act--${i + 1}`} data-testid={`st-act-${i + 1}`}>
        <div className="st-act-marker" aria-hidden="true">
          <span className="st-act-numeral">{act.numeral}</span>
        </div>
        <div className="st-act-content">
          <h3 className="st-act-title">{act.title}</h3>
          <div className="st-body st-act-body">
            {act.copy.map((p, j) => <p key={j}>{p}</p>)}
          </div>
        </div>
        {act.aside && <div className="st-act-aside">{act.aside}</div>}
      </li>
    ))}
  </ol>
);

const PRAISE = [
  { stars: 5, quote: "With writing as good as Wilmann’s, I hesitate as my words can never do it justice.", name: "Paul Wood", source: "CC Reviews" },
  { stars: 5, quote: "Most captivating, transforming piece of theatre I've seen in yonks.", name: "Patrick Strudwick", source: "The i Paper" },
  { stars: 5, quote: "Superb masterpiece.", name: "Lucy Ashe", source: "author of The Sleeping Beauties" },
  { stars: 4, quote: "A remarkably absorbing play.", name: "Paul Vale", source: "The Stage" },
];

export const StoryPraise = () => (
  <ul className="st-praise" data-testid="st-praise-list">
    {PRAISE.map((p) => (
      <li key={p.name} className="st-quote">
        <p className="st-stars" aria-label={`${p.stars} out of 5 stars`} data-testid="st-stars">
          {"★".repeat(p.stars)}<span className="st-stars-empty" aria-hidden="true">{"★".repeat(5 - p.stars)}</span>
        </p>
        <blockquote className="st-quote-text">
          <p>“{p.quote}”</p>
        </blockquote>
        <p className="st-quote-cite">– {p.name}, {p.source}</p>
      </li>
    ))}
  </ul>
);
